<template>
  <div class="service-container">
    <pre class="service-text">
<p>서비스 이용약관 <span>시행일 : 2021.08.01</span></p>
가맹점은 인성데이타주식회사(이하 “회사”라 함)가 제공하는 “대구로”의 서비스를 이용하기 위하여 아래의 약관에 모두 동의한다.

제1조【 목적 】

 이 약관은 인성데이타(주)(이하“회사”라 함)가 제공하는 대구형 배달앱 “대구로”(이하“서비스”라 한다) 서비스 이용과 관련하여 “회사”와 “서비스”를 이용하는 자간의 기본사항을 규정함을 목적으로 한다.

제2조【 정의 】

이 약관에서 사용하는 용어의 정의는 다음과 같다.

① “서비스”라 함은 이용자가 스마트폰, 태블릿, PC 등 각종 유무선 장치를 통하여 이용할 수 있도록 “회사”가 대구로라는 브랜드로 제공하는 모바일 중개 및 구매서비스를 말한다.

② “가맹점”이란 외식사업(식음료업) 및 배송의뢰를 위탁하는 일반사업자를 총칭하며, “회사”가 제공하는 “서비스”를 통해 “고객”에게 판매하는 자로서, 이 약관에 동의하고 “회사”가 정한 가입절차에 따라 등록을 완료하고, 회사의 정보를 지속적으로 제공받으며 서비스를 이용하는 자를 의미한다.

③ “대구로 사장님사이트” 이라 함은 회원가입신청 및 회원이 서비스를 통해 발생한 주문내역을 확인하고 관리, 운영할 수 있도록 회사가 제작하여 무료로 제공하는 웹페이지를 의미합니다.

④ “고객”이라 함은 “회사”의 “서비스”를 통하여 “가맹점”에서 제공하는 상품을 구매하는 자를 말한다.

⑤ “상품”이라 함은 “회사”가 제공하는 “서비스”를 통하여 “회원”에게 판매하는 재화 및 용역, 서비스 등을 말한다.

⑥ “쿠폰”이란 “회사”가 제공하는 “서비스”에 이용할 수 있는 결제수단이다.

⑦ “결제서비스”란 “고객”이 “상품”구매를 위하여 “서비스”이용을 위한 결제를 처리하는 서비스를 말한다.

⑧ “결제수단”이란 “상품”을 구매하기 위해 “고객”이 이용하고자 하는 현금, 지역화폐, 신용카드, 휴대폰, 상품권, 이체, 제3자 발생의 선불전자지급수단, 쿠폰 등 “상품”구매를 위해 지불할 수 있는 모든 방법을 말한다.

⑨ “결제프로그램”이란 “결제서비스”를 위하여 “회사”가 “가맹점”에게 제공하여 “가맹점”의 시스템 등에 설치하는 소프트웨어를 말한다.

⑩ “대금정산”이란 “회사”의 “결제서비스”를 이용하여 발생된 거래에 대하여 “회사”가 결제기관 등으로부터 구매대금을 지급받아 이를 “가맹점”이 지정한 정산 계좌에 지급하는 “회사”의 업무를 말한다.

⑪ “결제대금 선정산서비스”란 “회사”가 “상품”대금의 입․출금을 관리하며, “고객”의 “상품”수령 또는 이용 확인 후 “가맹점”에게 그 대금을 지급하는 서비스를 말한다.

⑫ “적립금”은 회사가 제공하는 프로그램상의 사이버 머니로서, 현금과 적립금의 교환비율은 1:1로서 운영되며 프로그램상의 각종 정산에 사용된다. 적립금의 충전은 회사가 지정한 가상계좌에 현금을 입금하면 프로그램상의 적립금으로 전환된다.

⑬ 본 조에서 정하지 않은 용어는 일반 관례 및 관련법령에서 정하는 바에 따라 해석하도록 한다.

제3조【 서비스이용 및 등록 】

① “가맹점”이 이 약관에 동의하고 “대구로”를 통하여 회사가 정한 가입절차를 완료한 경우, 서비스 이용신청이 완료된다. “가맹점”이 입력한 정보는 원활한 서비스제공을 위하여 “회사”가 서비스이용기간 동안 보유, 관리함을 원칙으로 한다.

② “회사”는 “가맹점”의 서비스이용신청에 대하여 승낙함으로써 본 약관이 적용되며, “회사”가 제공하는 서비스를 이용할 수 있도록 등록한다. 다만, “회사”는 다음 각 호에 해당하는 신청에 대하여는 승낙하지 않을 수 있다.

1. 회사가 정한 인증절차를 완료하지 않은 경우

2. 회사가 제시하는 내용을 기재하지 않는 경우

3. 실명이 아니거나 타인의 명의를 이용한 경우

4. 회사가 실명확인 절차를 실시할 경우에 이용자의 실명가입신청이 사실 아님이 확인된 경우

5. 등록내용에 허위의 정보를 기재하거나 기재누락, 오기가 있는 경우

6. 이미 가입된 회원과 전화번호나 전자우편주소가 동일한 경우

7. 부정한 용도 또는 영리를 추구할 목적으로 본 서비스를 이용하고자 하는 경우

8. 사회의 안녕질서 또는 미풍양속을 저해하거나, 저해할 목적으로 이용 신청한 경우

9. 기타 이 약관에 위배되거나 위법 또는 부당한 이용 신청임이 확인된 경우 및 회사가 합리적인 판단에 의하여 필요하다고 인정하는 경우

10. 기타 규정한 제반 사항을 위반하여 신청하거나, 기술상 또는 업무상 문제가 있는 경우

③ 제2항에 따라 서비스이용 신청을 승낙하지 아니하거나 유보한 경우, 회사는 이를 “가맹점”에게 알리도록 합니다.

④ “가맹점”은 이 약관에 동의하고, 회사가 정한 인증절차를 완료하여, 회사의 승인이 완료되면 회사의 영업상, 기술상 사정변경이 없는 한 서비스를 이용할 수 있습니다.

제4조【 서비스 종류 】

① 회사가 제공하는 서비스의 종류는 아래와 같다.

1. 재화 및 용역에 대한 주문중개 등 통신판매 중개서비스

2. 배달대행 연동서비스

3. 결제서비스 및 대금정산서비스

4. 기타 회사가 제공하는 모든 부가서비스(050서비스 포함)

② “회사”는 계약기간동안 “가맹점”에게 안정적인 “서비스”를 제공한다.

③ “회사”는 “가맹점”이 “서비스”를 이용하기 위하여 필요한 시스템 개발, 구축, 연동, 운영 등의 업무를 담당한다.

④ “가맹점”은 “회사”가 “서비스”의 제공 및 운영을 위하여, “가맹점”에게 시스템 개발, 구축, 연동 등을 요청하는 경우 이에 성실히 응하여야 한다.

⑤ “가맹점”은 “상품”의 정보, 가격 및 거래조건 등을 “대구로”에 게재하기 위하여 필요한 정보를 “회사”에 제공하여야 하며, “회사”에 제공한 자료 및 정보가 변경 또는 추가되는 경우 “회사”에 통지하여야 한다.

⑥ “회사”는 계약의 해지, 계약기간 만료 등의 사유로 계약이 종료되는 경우 “가맹점”의 데이터를 파기할 수 있다.

제5조【 배달대행 연동서비스 】

① “회사”는 OPEN API를 통하여 “가맹점”이 제휴된 배달대행사에게 주문사항의 배달대행연동서비스를 제공한다. 다만, 배달대행사와 별도로 “가맹점”이 협의된 경우는 예외로 한다.

② 배달대행사가 “회사”가 제공하는 API의 사용에 제한이 있는 경우 본조 서비스를 “가맹점”에 제공하는데 제한이 있을 수 있다. 이 경우에 “가맹점”은 배달대행사가 서비스를 제공하는데 동의할 수 있도록 협의를 해야 하며, 이에 대하여 “회사”에 책임을 물을 수 없다.

제6조【 서비스의 변경 및 중지 】

① “회사”는 서비스 제공과 관련하여 회사 정책의 변경 기타 운영상 기술상의 필요 등 다음 각 호의 상당한 이유가 있는 경우 제공하고 있는 서비스의 전부 또는 일부를 변경 또는 중단할 수 있다.

1. 서비스용 설비의 보수 등으로 인한 서비스 제공이 힘든 경우

2. 전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중지했을 경우

3. 국가비상사태, 정전, 서비스 설비의 장애 또는 서비스 이용의 폭주 등으로 정상적인 서비스 이용에 지장이 있는 때

4. 네트워크상의 위험성에 기초한 타인의 서비스 제공 음해 행위가 있는 경우

5. 서비스의 제공을 위한 정기점검이 필요한 경우

② 전 항에 의한 서비스 변경 및 중지의 경우 “회사”는 제10조에 정한 방법으로 “가맹점”에게 통지합니다. 단, 회사가 미리 예측할 수 없는 사정에 의한 서비스의 변경 및 중지의 경우에는 사후에 통지할 수 있다.

③ 서비스의 내용, 이용방법, 이용시간에 대하여 변경 또는 서비스 중단이 있는 경우에는 변경 또는 중단될 서비스의 내용 및 사유와 일자 등은 그 변경 또는 중단전에 회사 웹사이트 또는 서비스 내 공지사항 화면 등 이용자가 충분이 인지할 수 있는 방법으로 사전에 공지한다.

제7조【 서비스의 이용 제한 】회사는 이용자가 아래 각호에 해당하는 경우 서비스의 이용을 제한할 수 있습니다.

1. 정보를 허위로 기재한 경우

2. 약관 및 관련된 별도의 서비스 준수 사항을 위반하는 경우

3. 현행법령 및 사회통념에 반하는 행위를 하는 경우

4. 회사의 영업을 방해하거나 회사가 제공하는 서비스와 동일한 업무를 행하는 경우

제8조【 약관의 효력 및 변경 】

① “회사”는 이 약관의 내용을 회원이 쉽게 알 수 있도록 “대구로”를 통하여 게시하며, 이 약관은 “회사”가 게시함으로써 약관 시행일로부터 그 효력이 발생합니다.

② 회사는 약관의 규제 등에 관한 법률, 전자거래기본법, 전자서명, 정보통신망 이용촉진 등에 관한 법률 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있으며, 이 경우 개정내용, 적용일자 및 개정사유를 명시하여, 현행약관과 함께 비스의 초기 화면에 그 적용일자 최소 7일 이전부터 공지한다. 단, 변경내용이 “가맹점”에게 불리한 내용이거나 “가맹점”에게 중요한 부분이 변경되는 경우에는 이 약관의 변경 적용일자 최소 30일 이전부터 공지한다.

③ “가맹점”은 신설 또는 변경된 약관에 동의하지 않을 경우 개정약관을 적용할 수 없고, 이 경우 회원은 이용계약을 해지한다.

④ 회사가 전항에 따라 개정 약관을 공지 또는 통지하면서 회원에게 7일 또는 30일 기간 내에 의사표시를 하지 않으면 개정약관에 동의하는 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 따로 통지하였음에도 회원이 해당기간 내에 명시적으로 거부의 의사표시를 하지 아니한 경우 “회원”이 개정 약관에 동의한 것으로 본다. 가맹점이 신설 또는 변경된 약관의 효력발생일 이후에도 서비스를 계속 사용할 경우 약관의 변경함에 동의한 것으로 본다.

제9조【 약관 외 준칙 】

① 약관에서 정하지 않은 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한 법률, 기타 관련 법령 또는 상관례에 따릅니다.

② “회사”는 이 약관에서 규정되지 않은 사항에 대하여 구체적인 운영정책 등을 수립하여 “가맹점”에게 공지함으로써 계약의 일부를 구성할 수 있다.

③ “회사”는 특정서비스에 관한 내용을 별도의 약관에 규정할 수 있으며, 제10조에 따라 통지하고 “가맹점”이 이에 동의한 경우 개별약관은 이 약관에 우선하여 적용한다.

제10조【 “가맹점”에 대한 통지 】

① “회사”가 “가맹점”에 대한 통지를 하는 경우 “대구로 사장님사이트”상에 공지 내지 가입 당시 등록한 연락처를 이용한 방법으로 통지한다.

② 회사는 불특정 다수에 대한 통지의 경우 서비스 초기 화면에 1주일 이상 해당 내용을 기재함으로써, 개별통지에 갈음할 수 있습니다.

제11조【 회사의 의무 】

① “회사”는 “가맹점”에게 지속적이고 안정적인 서비스를 제공하며, 신의성실이 원칙에 따라 관리하여야 할 의무가 있다.

② “회사”는 관계법령 및 약관에 위반되는 행위를 하지 않으며, “고객”의 민원처리에 적극 협조하며, “가맹점”과 “고객”간의 분쟁이 발생하는 경우 분쟁해결 및 조정을 위해 노력해야 한다.

③ “회사”는 “서비스”와 관련하여 “가맹점”의 정당한 요청이 있는 경우 이를 개선하기 위하여 노력해야 한다.

제12조【 가맹점의 의무 】

① “가맹점”은 관계법령을 준수하며, “대구로”에서 제공하는 모든 서비스(상품의 제작, 배달을 포함)와 관련하여 선량한 관리자의 주의를 다하여야 한다.

② “가맹점”은 “고객”이 상품의 구매취소, 반품, 환불 등을 요청하는 경우 즉시 “회사”에 통보하여야 하며, 이와 관련하여「여신전문금융업법,「정보통신망 이용촉진 및 정보보호 등에 관한 법률,「전자상거래 등에서의 소비자 보호에 관한 법률」등 관련 법령을 준수하여야 한다.

③ “가맹점”은 “회사”의 “서비스”를 이용하는 과정에서 취득하는 각종 주문 통계자료, “고객”리뷰 등을 본 계약 외의 목적으로 제공하거나 판매하는 등의 행위를 하여서는 아니된다.

④ “가맹점”은 “회사”가 “서비스”와 관련하여 “가맹점”에게 정당한 요청을 하는 경우 “회사”의 요청에 따라야 한다.

⑤ “가맹점”은 “상품”의 정보, 가격 등을 허위, 오표시 등을 하지 않아야 한다.

⑥ “가맹점”은 다음의 행위를 하여서는 아니되며, 아래 각 호의 경우 “회사”는 “가맹점”이 현재 이용중인 서비스를 중단하고 이 약관의 규정에 따라 서비스이용을 제한할 수 있다.

1. 인증절차 및 이용신청 시 허위내용의 등록

2. 타인의 명의 및 정보 도용

3. 타인을 사칭하는 행위

4. 서비스상에 회사가 게시한 정보의 임의변경

5. 다른 이용자의 개인정보를 수집하는 행위

6. 디스어셈블, 디컴파일, 리버스엔지니어링, 및 기타 일체의 가공행위를 통하여 서비스를 복제, 분해, 또는 모방 기타 변현하는 행위

7. 자동접속 프로그램 등을 사용하는 등 정상적이지 않은 방법으로 서비스를 이용하여 회사의 서버에 부하를 일으켜 회사의 정상적인 서비스를 방해하는 행위

8. 회사와 사전 협의없이 이용자 본인이 아닌 제3자에게 접속권한을 부여하는 행위

9. 회사와 기타 제3자의 지적재산권에 대한 침해행위

10. 회사와 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위

11. 본인 또는 제3자의 영리를 위하여 서비스를 이용목적 외로 사용하는 행위

12. 현행법령 및 사회통념에 반하는 기타 불법적이거나 부당한 행위

⑦ “가맹점”은 본 서비스의 이용을 통해 지독한 구매회원의 개인정보를 개인정보보호법 및 기타 관계법령에서 정하는 바에 따라 보호 및 관리하여야 하며, 서비스 제공(재화 및 용역의 판매)목적 이외의 용도로 사용하여서는 아니된다.

⑧ “가맹점”이 본조를 위반하는 경우, 그로 인한 민, 형사상의 모든 책임은 해당 “가맹점”이 부담하여, “가맹점”의 위반행위로 인해 “회사”에 손해가 발생한 경우 “가맹점”은 그에 대한 법적책임을 부담한다.

제13조【 정보수집 】

① “회사”는 “서비스”제공을 위하여 관계 법령이 허용하는 범위내에서 “가맹점”에 대한 상호, 대표자, 전화번호, 주소, 통장사본, 사업자등록번호 및 상품 등에 대한 정보를 수집할 수 있으며, 이에 대해 “가맹점”은 성실히 협조하여야 한다.

② “회사”는 “서비스”제공에 필요한 경우에는 수집한 정보를 “고객”에게 제공할 수 있다.

③ “회사”는 “가맹점”이 제공한 정보를 확인하기 위하여 관계법령이 허용하는 범위 내에서 증빙자료를 수집할 수 있으며, “가맹점”이 이에 응하지 않는 경우에는 “서비스” 제한 및 계약해지 등을 할 수 있다.

④ “가맹점”은 정보를 허위로 제공해서는 안되며, 제1항에 따라 제공한 정보가 변경되었을 경우 즉시 “회사”에 통지하여야 하며, 정보가 변경된 것을 통지하지 않거나 잘못 통지하는 등의 사유로 발생하는 모든 손해는 회사의 고의 또는 중대한 과실이 없는 한 “가맹점”이 부담한다.

⑤ “가맹점”이 휴업 및 폐업 등을 하는 경우 해당 내용을 “회사”에 통지하여야 하며, 통지하지 않음으로 인해 발생하는 손해는 회사의 고의 또는 중대한 과실이 없는 한 “가맹점”이 부담하여, “회사”는 손해금액을 충당하기 위하여 “가맹점”에게 지급할 정산대금을 유보할 수 있다.

⑥ “회사”는 “가맹점”에게 제10조에 따라 통지한 경우 통지한 것으로 간주하고, “가맹점”의 연락처 오류기입 및 변경사항 미등록 등의 사유로 발생하는 손해는 회사의 고의 또는 중대한 과실이 없는 한 “가맹점”이 부담한다.

⑦ “회사”는 안정적인 서비스 운영을 위하여 제3자에게 “가맹점”의 정보를 제공할 수 있다.

⑧ “회사”는 지방자치단체의 요청이 있을 경우 “대구로”사업을 통해 수집된 정보를 제공할 수 있다.

제14조【 계약기간 】이 약관에 따른 계약기간은 “가맹점”이 서비스를 제공한 날로부터 1년간으로 하며, 기간 만료 30일전까지 계약 상대방에게 계약해지 의사표시를 하지 않는 경우 동일한 조건으로 1년간 자동 갱신된다.

제15조【 중개수수료 】

① “가맹점”은 서비스 중개수수료로 서비스를 통한 고객의 주문금액기준으로  2 % (VAT별도)를 “회사”에 납부한다. 단, 영업시장의 상황변동이나 “회사”의 정책변경이 있을 경우 상호 협의하여 수정할 수 있다.

② 정산은 “회사”가 정한 정산방식으로 처리하는 것을 원칙으로 하되, “가맹점”은 합리적인 사유를 들어 정산방식을 건의할 수 있고 이 때 “회사”는 “가맹점”의 건의를 진지하게 고려하여 수용할 수 있다. 만일 미정산이 발생하였을 경우 “가맹점”은 달리 협의하지 않는 한 즉시 “회사”에 현금으로 정산하여야 하며, “회사”는 “가맹점”에게 정산에 관한 상세내역을 제공해야 한다.

제16조【 대금의 정산 】

① “회사”는 “회사”의 “결제서비스”를 통해 발생한 거래승인 건 중 “회사”가 결제기관 등으로부터 대금을 지급받은 거래승인 건을 대상으로, 고객의 결제금액기준으로 2.2%(VAT별도)의 결제수수료를 공제한 후 본조의 정산시기 내에 “대금정산”을 완료하여야 한다.

② 대금정산 시기는 결제기관 또는 회사 영업일 기준으로 결제일+5일내로 정산한다.

③ “회사”는 “가맹점”이 결제 및 정산내역을 확인할 수 있도록 지원하여야 하며, “가맹점”과 “회사”가 확인한 결제내역이 서로 상이할 경우 상호 보유한 자료를 비교하여 정산금액을 협의할 수 있다.

④ 대금지급일이 토요일 및 공휴일의 경우 그 직후에 돌아오는 첫 번째 영업일에 대금을 정산한다.

⑤ “가맹점”과 “회사”가 “대금정산”과 관련하여 과오납이 있음을 발견한 경우에는 이를 지체 없이 상대방에게 통지하고 재정산 하여야 한다.

⑥ “회사”의 “대금정산”의무는 계약이 해지 또는 종료되더라도 정산대금이 존재하는 한 계속되는 것으로 한다.

⑦ “회사”의 “대금정산”시 “회사”는 정산대금에서 “가맹점”으로부터 지급받을 수수료를 상계한 후 그 잔액을 “가맹점”에게 지급한다.

제17조【 지급보류 】

① “회사”는 다음 각 호의 어느 하나에 해당하는 사유가 발생하는 경우 정산대금의 일부 또는 전부의 지급을 보류할 수 있으며, 지급보류시 “가맹점”에 그 사실을 유선 또는 서면으로 통지하여야 한다.

1. “가맹점”이 사업을 불법적으로 영위하거나 그 사업의 결과, 장래 거래 취소의 우려가 있는 경우

2. “가맹점”이 제33조에 정한 손해배상을 이행하지 아니한 경우

3. “가맹점”이 제3자로부터 정산대금에 관하여 가압류, 가처분 등 보전처분 또는 강제집행 등을 받은 경우

② 제①항의 정산대금이 이미 “가맹점”에 지급된 경우 “회사”는 “가맹점”에게 지급 예정인 차기 정산대금의 지급을 보류할 수 있다.

③ 지급보류 된 정산대금이 지급보류 사유의 해소로 “가맹점”에게 지급될 경우 특별한 사정이 없는 한 지급보류된 정산대금의 원금만 지급하며, “회사”는 고의, 중과실이 없는 한 지급보류로 인한 손해배상책임이 면제된다.

제18조【 주문 및 결제 】

① 본 서비스를 통한 “고객”의 주문은 해당 “가맹점”이 등록한 조건에 대하여 “고객”의 청약과 그에 대한 해당 “가맹점”의 승낙으로 체결된다.

② “고객”은 “회사”가 제공하는 방법에 의하여 구매를 신청할 수 있다.

③ “회사”는 모바일 결제 방식에 의한 대금지급 방법으로 현금 결제, 신용카드 결제, 선불카드 결제, 마일리지 기타 회사가 추가 지정하는 결제수단 등을 제공할 수 있다.

④ “고객”은 “대구로” 서비스를 통해 배달 주문을 하는 경우 주소, 연락처 등 배송지 정보에 대한 정확한 정보를 기재하여야 하며, “고객”이 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 “고객”이 부담한다.

제19조【 거래취소 】

① “고객”이 소비자보호 관계 법령 및 결제기관의 거래규정에 따라 “가맹점”에게 거래취소를 요청하는 경우 “가맹점”은 즉시 “회사”에게 거래취소를 요청해야 한다.

② “가맹점”은 거래취소 요청시 거래취소로 인하여 “회사”에 반환해야 할 정산대금을 “회사”가 정한 방법으로 동시에 반환하여 야 하며, 이에 따른 정산대금 반환이 이루어지지 않거나 결제기관에 의해 거래취소가 제한되는 경우 “회사”는 “가맹점”의 거래취소 요청을 거절할 수 있다.

③ “고객” 또는 결제기관이 “회사”에 거래취소를 요청하는 경우 “회사”는 그 요청내역을 “가맹점”에게 유선 또는 서면으로 통지하여야 하며, “가맹점”은 통지일로부터 제3영업일 이내에 그 처리결과를 서면으로 “회사”에 통지하여야 한다. 통지일로부터 제3영업일 이내에 그 처리결과의 통지가 없을 때에는 “회사”가 직접 취소 요청 건을 처리할 수 있으며, 그 처리결과를 “가맹점”에게 유선 또는 서면으로 통지한다.

④ “가맹점”이 “회사”의 운영정책 및 기타 관계 법령을 위반한 거래가 발생하는 경우에는 “회사”는 해당 거래를 취소할 수 있다.

⑤ 부정거래에 대하여는 “가맹점”이 직접 그 진위여부를 확인하고, “가맹점”의 기준에 의해 부정거래로 판단되는 거래에 대하여 직접 취소처리한다. 다만, “회사”가 부정거래를 인지한 경우에는 “회사”는 즉시 이를 “가맹점”에게 통지하여야 한다.

⑥ “회사”는 본조에 따른 거래취소 건으로 인하여 “가맹점”에게 반환받아야 할 정산대금이 있는 경우 지급 예정인 차기 정산대금에서 이를 공제할 수 있다.

제20조【 고객의 이의제기시 처리 】

① “결제서비스”의 이용과정에서 “결제서비스”와 관련하여 “고객”의 이의신청 및 민원이 발생할 경우 “회사”는 이를 즉시 “가맹점”에게 통보하고 “결제서비스” 제공자로서 자신의 책임하에 이를 해결하기 위하여 최선을 다하여야 하며, “가맹점”은 이에 성실히 협조한다.

② “고객”이 미사용 또는 “상품” 미배송 등 제①항 이외의 사유로 이의제기 등을 한 경우 상호 협의하에 귀책사유가 있는 쪽의 책임과 비용으로 이를 해결하여야 한다. 다만, “가맹점”의 책임이 명확한 경우 “회사”가 먼저 처리한 후 “가맹점”에게 그 비용에 대하여 비용을 청구할 수 있다.

제21조【 할인쿠폰 등 】

① “회사”는 “서비스”를 이용하는 “고객”을 대상으로 이벤트 프로모션 등 기타 운영정책에 따라 서비스를 통한 재화나 용역의 구매 시, 할인혜택을 발을 수 있는 할인쿠폰 등을 발급할 수 있다.



② 본조 ①항의 예외로 “가맹점”은 “가맹점”의 선택에 따라 “고객”들을 대상으로 자체할인쿠폰 등을 발급할 수 있으며, 이 경우 해당 “고객”에게 제공된 할인금액은 해당 “가맹점”이 부담한다.

제22조【 배달 】

① “고객”이 “가맹점”에게 대하여 본약관 제19조 따라 체결된 주문 건을 취소하는 경우 해당 주문건에 대한 최종 반품, 환불 여부는 해당 “가맹점”이 정하는 바에 따른다.

② 재화나 용역의 주문 및 배달과 관련하여 “가맹점”과 “고객”간 분쟁이 발생하는 경우 해당 분쟁은 회사가 관련 법령에 따라 법률상 책임을 지는 경우를 제외하면 당사자인 “가맹점”과 “고객”이 해결하여야 한다.

제23조【 반품 및 환불 】 “고객”이 “가맹점”에 대하여 본조 제19조 따라 체결된 주문 건을 취소하지 않는 경우 해당 주문 건에 대한 최종 반품, 환불에 대한 사항 및 기타 이와 관련하여 회사의 책임 없는 사유로 인해 발생하는 주문 및 결제 장애 등에 대해 “회사”는 관련 법령에 따라 법률상 책임을 지는 경우를 제외하면 어떠한 책임도 부담하지 아니한다.

제24조【 게시물 】

① “가맹점”이 “회사”가 제공하는 서비스 내에 게시한 게시물의 저작권은 “가맹점”에게 귀속되며, 게시물에 대한 저작권 사용 책임은 “가맹점”에 있다. 단, “회사”는 “가맹점”이 게시한 게시물이 다음 각 호의 어느 하나에 해당하는 경우에는 해당 게시물을 삭제할 수 있다.

1. 다른 가맹점을 비방할 목적으로 허위 사실을 유포하여 타인의 명예를 훼손하거나 비방하는 게시물의 경우

2. 관계법령 내지 미풍양속에 위반되는 내용인 경우

3. 회사 또는 제3자의 저작권 등 기타권리를 침해하거나 제3자로부터 권리침해신고가 접수된 경우

4. 관계법령 및 공공기관의 지침에 위배되는 광고성 게시물의 경우

5. 게시물이 게시된 게시판 내지 관련 상품과 무관한 내용인 경우

6. 정당한 사유 없이 회사 또는 다른 가맹점의 영업을 방해하는 내용의 경우

② 위①항 단서와 관련하여 “회사”는 해당 게시물의 삭제 사실을 “가맹점”에게 사전 또는 사후 통지하되, 해당 통지는 삭제 게시물의 내용 등에 따라 생략할 수 있습니다.

③ “회사”는 “가맹점”이서비스 상에 게시한 게시물을 본 서비스 홍보 및 마케팅의 목적을 위해 별도의 대가지급 없이 사용할 수 있다.

④ “가맹점”이 “회사”의 서비스를 중지 또는 해지하는 경우, 해당 이용자가 작성한 게시물은 자동 삭제된다.

제25조【 저작권 】

① “회사”가 제공한 서비스 및 관련 부속 이미지 등에 대한 저작권은 모두 “회사”에 있습니다.

② “가맹점”은 “회사”가 소유한 위①항의 정보 등을 “회사”의 사전 동의 없이 임의로 변경, 삭제, 도용 및 유포할 수 없습니다.

③ “가맹점”은 서비스를 이용함으로써, 얻은 정보를 “회사”의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 아니된다.

④ “회사”는 본 조항을 위반하는 “가맹점”에 대하여 사전 통보 없이 서비스제공을 중지할 수 있습니다.

제26조【 시스템의 관리 】

① “회사”는 보다 나은 서비스의 제공을 위해 시스템을 업그레이드하거나 제휴업체를 변경할 수 있다.

② 서비스가 전체시스템 과부하의 원인을 제공한다고 판단될 경우 “회사”는 해당 회원에게 사전 통보 후 서비스이용을 제한할 수 있습니다.

제27조【 정보의 제공 】“회사”는 “가맹점”이 서비스를 이용하는 과정에서 필요하다고 판단되는 다양한 정보와 서비스를 이용하여 제공할 수 있습니다.

제28조【 비밀유지의 의무 】 “회사”와 “가맹점”은 본 서비스를 이용하면서 알게 된 “회사”의 영업상의 비밀 및 고객의 인적 사항 등을 타인에게 누설하거나 직접 또는 제3자에게 이용하게 하여서는 아니 되며 본 계약이 종료된 이후 또한 이와 같다.

제29조【 개인정보보호 】

➀ “회사”와 “가맹점”은 서비스와 관련된 개인정보보호를 위해 적극적으로 협조・노력해야 한다.

➁ “회사”는 관련법령에 의한 정보처리 책임자 및 관리자로서의 의무를 다하여야 하며, “가맹점”은 “회사”의 관련법령과 관계된 모든 정책 및 지침을 준수해야 하며 이를 위반한 모든 책임을 부담한다.

➂ “가맹점”은 본 계약에 따라 “회사”의 시스템에 등록된 모든 정보에 대하여 개인정보보호법 또는 정보통신망 이용촉진 및 정보보호 등에 관한 법률상의 개인정보(이하 “개인정보”라 함)를 수집, 생성, 기록, 저장, 보유, 가공, 편집, 검색, 출력, 정정, 복구, 이용, 제공, 공개, 파기 그 밖에 이와 유사한 행위(이하 “처리”라 함)를 함에 있어 관련법령에 의한 정보처리 책임자 및 관리자인 “회사”의 사전 승인을 득하여야 한다.

➃ “가맹점”이 제3항의 개인정보 처리와 관련하여 관련 법령상의 의무나 본조에서 정한 의무를 위반한 경우 모든 법률상의 책임은 “가맹점”이 부담한다.

제30조【 권리양도 및 처분금지 】“가맹점”은 본 계약 및 관련 약정에 따라 취득한 계약상의 지위 및 권리를 “회사”와의 사전 협의없이 제3자에게 양도, 처분, 담보설정, 대여 등의 일체의 행위를 할 수 없다.

제31조【 불가항력 】양 당사자 중 어느 일방도 합리적으로 통제할 수 없는 천재지변 및 산업혼란, 재앙, 폭동, 반란 등으로 인한 불가항력적 요인으로 인해 본 계약상의 의무를 불이행하거나 지연에 대하여는 책임을 지지 않는다. 이 경우에 해당 당사자는 계약상대방에게 상세사항과 향후 진행계획 등을 상대방에게 고지하여야 하며, 원인이 제거된 직후 신속히 본 계약상의 내용을 이행해야 한다.



제32조【 계약의 해지 】

① “가맹점”과 “회사”는 상호 협의에 따라 본 계약을 해지할 수 있으며, 어느 일방이 본 계약의 계약사항을 위반하거나 충실히 이행하지 않는 경우 상대방에게 개선을 요구할 수 있고 개선요구일로부터 30일 이내에 위반사항이 시정되지 않을 경우 본 계약을 해지할 수 있다.

② 전항의 규정에도 불구하고 “가맹점”과 “회사”는 다음 각 호의 어느 하나에 해당하는 사유가 발생하는 즉시 계약을 해지할 수 있다.

1. 본 계약 또는 관련 개별 약정을 중대하게 위반한 경우.(계약시 제출한 서류허위 등을 포함)

2. 상대방에 심각한 손해를 끼친 경우(이미지 및 명예훼손 등을 포함)

3. 업무 수행상 취득한 고객의 제반 정보를 위법ㆍ부당하게 유출, 사용하거나 이로써 이득을 취한 경우 또는 제3자로 하여금 위법ㆍ 부당하게 유출, 사용하게 하거나 이로써 이득을 취한 경우.

4. 기타 본 계약의 이행이 현저히 어려운 사항이 발생한 경우

③ 계약해지에 귀책사유가 있는 당사자는 상대방에게 발생한 손해를 배상하여야 한다.

제33조【 손해배상 등 】

① 본 계약의 일방 당사자가 계약사항을 위반하거나 책임있는 사유로 상대방 또는 제3자에게 손해가 발생한 경우, 귀책 당사자는 상대방 또는 제3자의 직‧간접 손해 일체를 배상하여야 한다.

➁ 다음 각 호의 경우 “회사”는 “가맹점”에게 손해에 대하여 청구할 수 있다.

1. “가맹점”의 불법행위로 인해 “회사”가 입은 손해금액

2. “가맹점”가 업무처리지침을 소홀히 하여 고객 불편을 초래하거나 “회사”의 기업이미지를 손상시킨 객관적인 피해가 발생한 경우

3. “가맹점”이 “회사”와 합의되지 않은 서비스의 진행 및 중단으로 인해 손해가 발생하였을 경우

③ 본 계약 또는 관련 약정의 업무수행 중 발생하거나 본 계약 또는 관련 약정의 위반‧해지‧종료 등으로 인하여 “회사” 또는 “고객” 등 제3자에게 발생한 손해에 대하여 “가맹점”의 영업상 및 관리‧감독상 귀책이 있는 경우에는 “회사”에 귀책사유가 없는 이상 “가맹점”만이 배상책임을 부담한다.

④ “회사”는 “가맹점”에게 지급할 금액이 있는 경우 본조에 의한 손해배상액이 확정되면 그 금액에서 손해발생액을 우선 변제에 충당할 수 있다.

제34조【 결제서비스 】

① “회사”의 “결제서비스”는 연중 무휴 24시간 제공을 원칙으로 한다. 다만, “결제기관”의 사정에 따라 달리 정할 수 있다.

② “회사”는 “결제서비스”의 품질 향상 및 정기점검 등의 기술적 필요에 의하여 일시적인 “결제서비스” 중단이 불가피한 경우 “회사”는 “결제서비스” 중단 3일전까지 사전 통보하여 “가맹점”의 “결제서비스” 이용에 불편이 없도록 한다. 다만, 천재지변 또는 긴급한 필요가 있는 경우에는 사전 통보없이 “결제서비스”를 중단할 수 있으며, 중단조치 후 24시간 이내에 “가맹점”에게 “결제서비스” 중단사실을 통보하여야 한다.

③ “가맹점”이 계약상의 의무를 이행하지 않는 경우 “회사”는 그 사유의 해소일까지 일시 “결제서비스” 제공을 중단할 수 있다.

제35조【 면책 】

① “회사”는 “가맹점”과 “고객”간의 거래를 중개하는 통신판매 중개자로서 플랫폼 서비스만을 제공할 뿐, 재화 및 용역을 판매 제공하는 당사자가 아닌 바, 가맹점”과 “고객”간의 서비스를 통한 거래에 대해 고의 또는 중과실이 없는한 어떠한 책임도 부담하지 아니한다.

② “회사”는 천재지변, 전쟁, 기간통신 사업자의 서비스 중지 및 기타 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 대한 책임이 면제된다.

③ “회사”는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대하여 고의 또는 중과실이 없는 한 책임이 면제됩니다.

④ “회사”는 “가맹점”의 단말기 오류에 의한 손해가 발생한 경우 또는 “가맹점”의 신상정보 및 전자우편주소를 부실하게 관리하여 손해가 발생한 경우에도 고의 또는 중과실이 없는 한 책임을 부담하지 아니한다.

⑤ “회사”는 “가맹점”의 귀책사유로 인한 서비스 이용의 장애에 대하여도 고의 또는 중과실이 없는 한 책임을 부담하지 아니한다.

⑥ “회사”는 “가맹점”이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대하여 책임을 지지 아니하며, 서비스를 이용하면서 얻은 자료로 인한 손해에 대하여 고의 또는 중과실이 없는 한 책임을 지지 않는다.

⑦ “회사”는 “가맹점”이 서비스를 사용하는 과정에서 등록한 각종 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 대하여 책임을 지지 않으며, 이용자 상호간 및 이용자와 제3자 상호간에 서비스를 매개로 발생한 분쟁에 대하여 개입할 의무가 없고, 고의 도는 중과실이 없는 한 이로 인한 손해를 배상할 책임도 없다.

⑧ “회사”는 “회사”가 네트워크를 통한 외부의 불법행위를 차단하고자 기술적인 보호조치를 이행하였음에도 불구하고, 분산서비스(DDos) 등 네트워크의 안정성을 해치는 행위 또는 허가 받지 않은 정보 시스템에 침투하는 행위 등에 의하여 발생하는 예기치 못한 이용자의 손해에 대하여는 어떠한 배상도 하지 않는다.

⑨ “회사”는 서버 등의 기계적인 장치와 관련하여 예상치 못한 오작동 및 고장 등과 관련하여 회사의 중/과실이 없는 한 어떠한 책임도 지지 않는다.

제36조【 식품 등의 이물 발견신고 등 】 “가맹점”은 식품위생법 제46조 ②항에 따라 “고객”으로부터 “가맹점”에게 이물 발견의 신고 접수를 하는 경우에는 즉시 이를 “회사”에 통보하여야 한다.



제37조【 리뷰관리 】

① “회사”는 “가맹점”으로부터 “상품”을 구매한 “고객”이 리뷰 작성을 할 수 있도록 서비스를 제공한다.

② “회사”는 “고객”이 작성한 “가맹점”의 리뷰에 대하여 다음 각 호의 어느 하나에 해당하는 경우 삭제 등을 할 수 있다.

1. 범죄적 행위에 해당하는 경우

2. 자신의 가게 홍보 목적으로 자신 또는 제3자에게 위법 부당한 방법으로 허위 또는 과장된 리뷰를 쓴 경우

3. 위법 부당한 방법으로 자신 또는 제3자의 가게에 리뷰를 쓴 경우

4. 개인정보(성명, 주소, 전화번호 등)가 리뷰에 노출된 경우

5. 폭언, 욕설, 성희롱 등이나 리뷰를 사용하는 자로 하여금 불쾌감이나 혐오감을 줄 수 있는 내용을 담고 있는 경우

③ “고객”이 작성한 리뷰에 대하여 이의가 있는 “가맹점”은 그 리뷰의 삭제를 “회사”에 요청할 수 있으며, “회사”는 관계법령 및 정책에 따라 처리할 수 있다. 다만, 그 리뷰가 정상적인 “고객”의 리뷰이ᅟᅵᆫ 경우 별도의 처리를 하지 않을 수 있다.

제37조【 분쟁의 해결 】 서비스에 관한 분쟁이 발생한 경우 “가맹점”과 “회사”간의 합의로 해결함을 원칙으로 한다. 다만, “가맹점”과 “회사”간에 합의할 수 없거나 합의가 이루어지지 않아 소송이 제기된 경우 관할 법원은 “회사”의 본점 소재지를 관할하는 법원으로 한다.

부칙  이 약관은 2021년 8월 1일부터 시행합니다.




    </pre>
  </div>
</template>

<script>
export default {
  name: "Service"
}
</script>

<style scoped>
.service-container{
  padding: 50px;
}
.service-text{
  font-family: "NanumSquareNeoBold";
  white-space: pre-wrap;
  word-wrap: break-word;
  text-align: justify;
  font-size: 13px;
}
.service-text p{
  border-bottom: 1px solid #333;
  padding-bottom: 15px;
  font-size: 25px;
}
.service-text p span{
  float: right;
  margin-top: 10px;
  font-size: 14px;
}
@media all and (min-width: 1024px){
  .service-container{
    width: 1280px;
    margin: 0 auto;
  }
}
@media all and (min-width: 768px) and (max-width: 1023px){
  .service-container{
    width: 768px;
    margin: 0 auto;
  }
}
@media all and (max-width: 767px){
  .service-container{
    width: 100%;
    padding: 25px;
  }
}
</style>